<script setup>
import { ref, computed } from "vue"

const props = defineProps({
    title: {
        type: String
    },
    subtitle: {
        type: String
    },
    positionX: {
        type: String,
        default: 'right',
        validation: (value) => {
            return ['left', 'center', 'right'].indexOf(value) !== -1
        }
    },
    positionY: {
        type: String,
        default: 'middle',
        validation: (value) => {
            return ['top', 'middle', 'bottom'].indexOf(value) !== -1
        }
    },
    iconPosition: {
        type: String,
        default: 'left',
        validation: (value) => {
            return ['left', 'right', 'top', 'bottom'].indexOf(value) !== -1
        }
    },
    border: {
        type: Boolean,
        default: false
    },
    dark: {
        type: Boolean,
        default: false
    }
})

const getContainerPositionXClass = computed(() => {
    if (props.positionX == "left") {
        return 'right-[calc(100%+16px)]'
    } else if (props.positionX == "right") {
        return 'left-[calc(100%+16px)]'
    } else if (props.positionX == "center") {
        return 'left-[50%] translate-x-[-50%]'
    }
})

const getContainerPositionYClass = computed(() => {
    if (props.positionY == "top") {
        return 'bottom-[calc(100%+5px)]'
    } else if (props.positionY == "bottom") {
        return 'top-[calc(100%+5px)]'
    } else if (props.positionY == "middle") {
        return 'top-[50%] translate-y-[-50%]'
    }
})

const getIconPositionClass = computed(() => {
    if (props.iconPosition == "left") {
        return 'translate-x-0 -translate-y-2/4 left-[-7px] top-2/4'
    } else if (props.iconPosition == "right") {
        return 'translate-x-0 -translate-y-2/4 right-[-7px] top-2/4 rotate-180'
    } else if (props.iconPosition == "top") {
        return 'top-[-11px] rotate-90 left-2/4'
    } else if (props.iconPosition == "bottom") {
        return 'bottom-[-11px] rotate-[270deg] left-2/4'
    }
})


const show = ref(false)
</script>

<template>
    <div @mouseover="show = true" @mouseleave="show = false" class="relative">
        <slot></slot>
        <div v-if="show" class=" z-[99] absolute p-3 text-start bg-white rounded-lg shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08)]" :class="getContainerPositionXClass, getContainerPositionYClass, { 'w-[320px]': props.subtitle }, { 'border border-[#F2F4F7]': props.border }, { 'bg-[#101828]': props.dark }">
            <!-- content -->
            <div class="text-xs font-semibold leading-normal" :class="props.dark ? 'text-white' : 'text-[#344054]'" v-if="props.title">{{ props.title }}</div>
            <div class="mt-1 text-xs font-medium leading-normal" :class="props.dark ? 'text-white' : 'text-[#667085]'" v-if="props.subtitle">{{ props.subtitle }}</div>

            <!-- arrow icon -->
            <svg class="absolute" :class="getIconPositionClass" width="9" height="17" viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.51471 14.5711C8.51471 15.462 7.43757 15.9081 6.8076 15.2782L0.736529 9.2071C0.346004 8.81658 0.346005 8.18342 0.736529 7.79289L6.8076 1.72183C7.43757 1.09187 8.51471 1.53803 8.51471 2.42894L8.51471 14.5711Z" :fill="props.dark ? '#101828' : 'white'" />
            </svg>
        </div>
    </div>
</template>


<style>

</style>